import { getImageBaseUrl } from "../services/s3-utils";

export const ROUTES = {
  ADMIN_LOGIN: "/in-house/login",
  ADMIN_DASHBOARD: "/in-house/dashboard",
  ADMIN_COURSES: "/in-house/courses",
  ADMIN_TEAMMEMBERS: "/in-house/team-members",
  INSTRUCTOR_DASHBOARD: "/instructor/dashboard",
  INSRTUCTOR_PROFILE: "/instructor/profile",
  INSTRUCTOR_COURSES: "/instructor/courses",
  INSTRUCTOR_COURSE_PREVIEW: (id) => `/instructor/courses/preview/${id}`,
  INSTRUCTOR_MESSAGES: "/instructor/messages",
  INSTRUCTOR_SINGLE_COURSE: (id) => `/instructor/courses/${id}`,
  INSTRUCTOR_COURSE_OVERVIEW: (id) => `/instructor/course/overview`,
  CATEGORIES: (id) => `/categories/${id}`,
  COURSE_OVERVIEW: (id) => `/overview/${id}`,
  INSTRUCTOR_PERFORMANCE: "/instructor/performance",
  INSTRUCTOR_PROMOTIONS: "/instructor/promotions",
  INSTRUCTOR_SETTINGS: "/instructor/settings",
  INSTRUCTOR_SIGNUP: "/instructor/signup",
  LEARNER_PROFILE: "/learner/profile",
  LEARNER_MESSAGES: "/learner/messages",
  LOGIN: "/login",
  SIGNUP: "/signup",
  SEARCH: (param) => `/search/${param}`,
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: (id) => `/reset-password/${id}`,
  BASE: "/",
  INTERESTS: "/interest",
  TEST: "/test",
};

export const LEVELS = ["BEGINNER", "INTERMEDIATE", "ADVANCED"];

export const SKILLS = [
  "VERBAL",
  "NON-VERBAL",
  "DIGITAL",
  "BEHAVIORAL",
  "EMPIRICAL",
  "SOCIAL",
  "EMOTIONAL",
  "VERBAL 2",
  "NON-VERBAL 2",
  "DIGITAL 2",
  "BEHAVIORAL 2",
  "EMPIRICAL 2",
  "SOCIAL 2",
  "EMOTIONAL 2",
];

export const VALUES = [
  {
    title: "Collaboration",
    description:
      "Collaboration is the process of two or more people or organizations working together to complete a task or achieve a goal. ",
  },
  {
    title: "Transparency",
    description:
      "Transparency, as used in science is operating in such a way that it is easy for others to see what actions are performed.",
  },
  {
    title: "Trust",
    description:
      "Trust will help us foster a positive and productive environment that delivers value to our users and customers.",
  },
  {
    title: "Integrity",
    description:
      "Integrity is the practice of showing a consistent and uncompromising adherence to strong moral and ethical principles.",
  },
];

export const HIRING_PROCESS = [
  {
    image: `${getImageBaseUrl}/assets/juicy-resume-2 1.png`,
    title: "Application Process",
    description:
      "We’ll usually put out our job calls first in our newsletters here and then on our social media and our application process is usually short enough for us to know about you but not long enough to force you to abandon it.",
  },
  {
    image: `${getImageBaseUrl}/assets/juicy-woman-is-looking-for-perfect-candidate-1+1.png`,
    title: "Application Review",
    description:
      "Your application will be reviewed by the head of the department that’s hiring, our HR person and also the CEO. We’ll be sure to get back to everyone with a response.",
  },
  {
    image: `${getImageBaseUrl}/assets/juicy-online-meeting-on-laptop 1.png`,
    title: "Interview Process",
    description:
      "It's usually a three step interview process at Qalort. First, to access your past experience and skill level; second, a short task to understand your work process; third, a culture fit interview.",
  },
  {
    image: `${getImageBaseUrl}/assets/juicy-recruitment 1.png`,
    title: "Job Offer & Employment Process",
    description:
      " If you’re successful, we’ll send you an offer letter and a contract. Then the onboarding process begins and your work as a Qalort star is in full swing.",
  },
];

export const QALORT_FAQS = [
  {
    question: "What’s Qalort all about?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
  {
    question: "What makes Qalort different?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
  {
    question: "Can this be a side hustle?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
  {
    question: "Can I learn anything?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
  {
    question: "What is early access and how can I get it?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
  {
    question: "How many courses does the Qalort platform offer?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
  {
    question: "What do the courses include?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
  {
    question: "How do I take courses on Qalort? Is there a plan?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
  {
    question: "Is Qalort mobile friendly?",
    answer:
      "Well, Qalort is simply an online learning platform filled with a massive amount of content or we hope to be someday, tailored or freely browsed to help you reach your skills and knowledge potential.",
  },
];

export const VIDEOSDK = "VIDEOSDK";
export const DAILY = "DAILY";
